import type { ParsedBusiness } from "~/data/.server/business";

export function ComplaintsSection(props: {
  business: ParsedBusiness;
}) {
  const { company } = props.business;

  // Calculate total complaints
  const totalComplaints = company.complaints?.reduce(
    (c, total) => c + (total?.count ?? 0),
    0,
  );

  // Complaints by Year
  const complaintsByYear = company.complaintStatistics;

  // Complaints by Category
  const complaintsByCategory = company.complaints?.reduce(
    (acc, complaint) => {
      const category = complaint?.category || "Unknown";
      if (!acc[category]) {
        acc[category] = 0;
      }
      acc[category] += complaint?.count || 0;
      return acc;
    },
    {} as Record<string, number>,
  );

  return (
    <>
      {/* Total Number of Complaints */}
      <div className="mb-6">
        <p>
          <span className="font-semibold">Total Number of Complaints:</span>{" "}
          {totalComplaints ?? 0}
        </p>
      </div>

      {/* Complaints by Year */}
      <div className="mb-6 max-w-full overflow-x-scroll">
        <h3 className="mb-2 font-semibold">Complaints by Year</h3>
        {(complaintsByYear?.length ?? 0 > 0) ? (
          <table className="min-w-full border">
            <thead>
              <tr>
                <th className="border px-4 py-2">Year</th>
                <th className="border px-4 py-2">Total Complaints</th>
              </tr>
            </thead>
            <tbody>
              {complaintsByYear?.map((stat, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2">{stat?.year || "N/A"}</td>
                  <td className="border px-4 py-2">{stat?.count || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No complaint statistics available.</p>
        )}
      </div>

      {/* Complaints by Category */}
      <div className="mb-6 max-w-full overflow-x-scroll">
        <h3 className="mb-2 font-semibold">Complaints by Category</h3>
        {Object.keys(complaintsByCategory ?? {}).length > 0 ? (
          <table className="min-w-full border">
            <thead>
              <tr>
                <th className="border px-4 py-2">Category</th>
                <th className="border px-4 py-2">Count</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(complaintsByCategory ?? {}).map(
                ([category, count], index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2">{category}</td>
                    <td className="border px-4 py-2">{count}</td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        ) : (
          <p>No complaints by category available.</p>
        )}
      </div>
    </>
  );
}
